
<button #openModel  data-bs-toggle="modal" data-bs-target="#logoutmodal1"  hidden>Open</button>
<div class="modal fade" id="logoutmodal1" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-body logout_modal_body">
            <div class="logout_modal_body_inner">
              <img src="/assets/images/cancel.png" class="logout_cancel" alt="" data-bs-dismiss="modal" aria-label="Close">
              <p class="logout_heading">{{content?.header}}</p>
              <p class="logout_sub_heading">{{ content?.mainContent }}</p>
            </div>
          </div>
          <div class="modal-footer logout_modal_footer">
            <button type="button" class="btn logout_modal_cancel_btn"  #modalCloseButton data-bs-dismiss="modal" hidden>abc</button>
            <button type="button" class="btn logout_modal_cancel_btn"  #modalCloseButton data-bs-dismiss="modal" *ngIf="content?.leftButton!=''">{{content?.leftButton}}</button>
            <button type="button" class="btn logout_modal_btn" *ngIf="content?.rightButton=='Confirm'" (click)="confirmDelete()" >{{content?.rightButton}}</button>
            <button type="button" class="btn logout_modal_btn" *ngIf="content?.rightButton!='Confirm'" (click)="closeModal()">{{content?.rightButton}}</button>
          </div>
        </div>
      </div>
    </div>
  
    